import React, { useState, useEffect } from 'react';
import { AZUL, LARANJA, CINZA } from '../styles/colors';
import { listarProdutosPorEmpresa, buscarPerfil, logoutUsuario } from '../firebase';

const EMPRESAS = [
  { id: 'apoio', label: 'Apoio Elétricos' },
];

const NOMES_LINHAS = {
  'L': 'Lisse',
  'LP': 'Lisse Pass',
  'MA': 'Moduluz',
  'V': 'Volutta',
  'ILB': 'Ilia',
  'B': 'Basic',
  'BE': 'Basic',
  'BC': 'Basic Condulete',
  'XBC': 'Xburg',
  'XB': 'Xburg',
  'EX': 'Extra',
  'ILV': 'Ilia',
  'VV': 'Volutta',
  'ACESSORIOS': 'Acessórios',
  'OUTROS': 'Outros',
};

function nomeLinha(linha) {
  return NOMES_LINHAS[linha] || linha;
}

function Catalogo({ onNavegar, onAdicionarCarrinho, carrinho, perfilAtivo }) {
  const [empresaAtiva,   setEmpresaAtiva]   = useState('apoio');
  const [linhaAtiva,     setLinhaAtiva]     = useState('');
  const [busca,          setBusca]          = useState('');
  const [modalProduto,   setModalProduto]   = useState(null);
  const [qtdModal,       setQtdModal]       = useState(1);
  const [fotoZoom,       setFotoZoom]       = useState(null);
  const [modalVisita,    setModalVisita]    = useState(false);
  const [dataVisita,     setDataVisita]     = useState('');
  const [horarioVisita,  setHorarioVisita]  = useState('');
  const [vendedor,       setVendedor]       = useState(null);
  const [produtos,       setProdutos]       = useState([]);
  const [linhas,         setLinhas]         = useState([]);
  const [carregando,     setCarregando]     = useState(true);

  useEffect(() => {
    async function carregar() {
      setCarregando(true);
      setProdutos([]);
      setLinhaAtiva('');
      try {
        const lista = await listarProdutosPorEmpresa(empresaAtiva);
        setProdutos(lista);
        const linhasUnicas = [...new Set(lista.map(p => p.linha).filter(Boolean))].filter(l => l !== 'OUTROS');
        setLinhas(linhasUnicas);
      } catch (e) {
        console.error('Erro ao carregar produtos:', e);
      } finally {
        setCarregando(false);
      }
    }
    carregar();
  }, [empresaAtiva]);

  useEffect(() => {
    const perfil = perfilAtivo || JSON.parse(localStorage.getItem('perfil') || 'null');
    if (perfil?.vendedorId) {
      buscarPerfil(perfil.vendedorId)
        .then(v => setVendedor(v))
        .catch(e => console.error('Erro ao buscar vendedor:', e));
    }
  }, [perfilAtivo]);

  const itensCarrinho = carrinho || [];
  const totalCarrinho = itensCarrinho.reduce((acc, i) => acc + i.qtd, 0);

  async function handleSair() {
    if (!window.confirm('Deseja sair da sua conta?')) return;
    try { await logoutUsuario(); } catch (e) { console.error(e); }
    localStorage.removeItem('perfil');
    window.location.reload();
  }

  const navItems = [
    { id: 'home',      emoji: '🏠', label: 'Início'   },
    { id: 'catalogo',  emoji: '📦', label: 'Catálogo' },
    { id: 'carrinho',  emoji: '🛒', label: 'Carrinho' },
    { id: 'historico', emoji: '📋', label: 'Pedidos'  },
    { id: 'perfil',    emoji: '👤', label: 'Perfil'   },
  ];

  const produtosFiltrados = produtos.filter(p => {
    const matchLinha = linhaAtiva === '' || p.linha === linhaAtiva;
    const matchBusca = p.nome.toLowerCase().includes(busca.toLowerCase()) ||
                       p.cod.toLowerCase().includes(busca.toLowerCase());
    return matchLinha && matchBusca;
  });

  function handleEmpresa(id) {
    setEmpresaAtiva(id);
    setBusca('');
  }

  function abrirModal(produto) {
    setModalProduto(produto);
    setQtdModal(1);
  }

  function confirmarAdicao() {
    if (!modalProduto) return;
    onAdicionarCarrinho({ ...modalProduto, empresa: empresaAtiva, qtd: qtdModal });
    setModalProduto(null);
  }

  function getImgUrl(img) {
    if (!img) return null;
    if (img.startsWith('http')) return img;
    return `https://www.apoio.ind.br/media/img/produtos/${img}.jpg`;
  }

  function formatarPreco(preco) {
    if (preco === 0 || preco === '0') return 'Consultar';
    if (typeof preco === 'number') return `R$ ${preco.toFixed(2).replace('.', ',')}`;
    return preco;
  }

  function handleSolicitarVisita() {
    const perfil = perfilAtivo || JSON.parse(localStorage.getItem('perfil') || 'null');
    const nome = perfil?.razaoSocial || perfil?.nome || 'Cliente';
    const tel = vendedor?.whatsapp
      ? '55' + vendedor.whatsapp.replace(/\D/g, '')
      : '5511999990000';

    let msg = `Ola! Sou *${nome}*.\n\n`;
    msg += `Gostaria de agendar uma visita do representante Apoio Materiais Eletricos.\n\n`;
    if (dataVisita) msg += `Data preferida: *${dataVisita}*\n`;
    if (horarioVisita) msg += `Horario preferido: *${horarioVisita}*\n`;
    msg += `\nAguardo contato. Obrigado!`;

    window.open(`https://wa.me/${tel}?text=${encodeURIComponent(msg)}`, '_blank');
    setModalVisita(false);
    setDataVisita('');
    setHorarioVisita('');
  }

  return (
    <div style={{ flex: 1, display: 'flex', flexDirection: 'column', background: CINZA }}>

      {/* Header */}
      <div style={{ background: AZUL, padding: '14px 18px 0' }}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 12 }}>
          <div style={{ color: '#fff', fontSize: 16, fontWeight: 600 }}>Catálogo</div>
          <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
            <div onClick={() => onNavegar('carrinho')}
              style={{ position: 'relative', cursor: 'pointer', padding: 4 }}>
              <span style={{ fontSize: 22 }}>🛒</span>
              {totalCarrinho > 0 && (
                <div style={{ position: 'absolute', top: 0, right: 0, background: LARANJA, borderRadius: '50%', width: 16, height: 16, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 9, fontWeight: 700, color: '#fff' }}>
                  {totalCarrinho}
                </div>
              )}
            </div>
            <button onClick={handleSair}
              style={{ background: 'rgba(255,255,255,0.15)', border: 'none', borderRadius: 8, padding: '6px 12px', fontSize: 11, color: '#fff', cursor: 'pointer', fontWeight: 500 }}>
              Sair
            </button>
          </div>
        </div>

        <div style={{ background: 'rgba(255,255,255,0.12)', borderRadius: 10, padding: '9px 14px', display: 'flex', alignItems: 'center', gap: 8, marginBottom: 12 }}>
          <span style={{ fontSize: 12, color: 'rgba(255,255,255,0.5)' }}>🔍</span>
          <input
            value={busca}
            onChange={e => setBusca(e.target.value)}
            placeholder="Buscar por nome ou codigo..."
            style={{ background: 'transparent', border: 'none', outline: 'none', fontSize: 12, color: '#fff', flex: 1 }}
          />
        </div>

        <div style={{ display: 'flex', gap: 8 }}>
          {EMPRESAS.map(emp => (
            <button key={emp.id} onClick={() => handleEmpresa(emp.id)}
              style={{ flex: 1, background: empresaAtiva === emp.id ? '#fff' : 'rgba(255,255,255,0.12)', border: 'none', borderRadius: 8, padding: '8px 6px', fontSize: 11, fontWeight: 600, color: empresaAtiva === emp.id ? AZUL : 'rgba(255,255,255,0.7)', cursor: 'pointer' }}>
              {emp.label}
            </button>
          ))}
        </div>

        {/* Navegação no cabeçalho */}
        <div style={{ display: 'flex', borderTop: '1px solid rgba(255,255,255,0.15)', marginTop: 8 }}>
          {navItems.map(item => (
            <div key={item.id} onClick={() => onNavegar(item.id)}
              style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', padding: '8px 4px 10px', cursor: 'pointer', gap: 3, borderBottom: item.id === 'catalogo' ? '2px solid #fff' : '2px solid transparent' }}>
              <span style={{ fontSize: 18 }}>{item.emoji}</span>
              <span style={{ fontSize: 9, color: item.id === 'catalogo' ? '#fff' : 'rgba(255,255,255,0.6)', fontWeight: item.id === 'catalogo' ? 600 : 400 }}>{item.label}</span>
            </div>
          ))}
        </div>
      </div>

      {/* Filtro por linha */}
      <div style={{ background: '#fff', borderBottom: '1px solid #e8e8e5', padding: '10px 14px' }}>
        <div style={{ display: 'flex', gap: 7, overflowX: 'auto', paddingBottom: 2 }}>
          {linhas.map(linha => (
            <div key={linha} onClick={() => setLinhaAtiva(linhaAtiva === linha ? '' : linha)}
              style={{ flexShrink: 0, background: linhaAtiva === linha ? AZUL : '#f4f4f2', border: `1px solid ${linhaAtiva === linha ? AZUL : '#e0e0dd'}`, borderRadius: 20, padding: '5px 13px', fontSize: 11, fontWeight: 500, color: linhaAtiva === linha ? '#fff' : '#555', cursor: 'pointer', whiteSpace: 'nowrap' }}>
              {nomeLinha(linha)}
            </div>
          ))}
        </div>
      </div>

      {/* Grid de produtos */}
      <div style={{ flex: 1, overflowY: 'auto', padding: '12px 12px 0' }}>
        {carregando ? (
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: '48px 20px', gap: 10 }}>
            <span style={{ fontSize: 28 }}>⏳</span>
            <span style={{ fontSize: 13, color: '#999', fontWeight: 500 }}>Carregando produtos...</span>
          </div>
        ) : produtosFiltrados.length === 0 ? (
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: '48px 20px', gap: 10 }}>
            <span style={{ fontSize: 36 }}>🔍</span>
            <span style={{ fontSize: 13, color: '#999', fontWeight: 500 }}>Nenhum produto encontrado</span>
            <button onClick={() => { setBusca(''); setLinhaAtiva(''); }}
              style={{ marginTop: 8, background: AZUL, border: 'none', borderRadius: 8, padding: '8px 18px', fontSize: 12, color: '#fff', cursor: 'pointer', fontWeight: 500 }}>
              Limpar filtros
            </button>
          </div>
        ) : (
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10, paddingBottom: 12 }}>
            {produtosFiltrados.map(p => (
              <div key={p.id || p.cod} style={{ background: '#fff', borderRadius: 10, border: '1px solid #e8e8e5', overflow: 'hidden' }}>
                <div
                  onClick={() => p.img ? setFotoZoom({ url: getImgUrl(p.img), nome: p.nome }) : null}
                  style={{ height: 80, background: '#f8f8f7', display: 'flex', alignItems: 'center', justifyContent: 'center', position: 'relative', cursor: p.img ? 'zoom-in' : 'default' }}>
                  {p.img ? (
                    <>
                      <img src={getImgUrl(p.img)} alt={p.nome} style={{ width: '100%', height: '100%', objectFit: 'contain', padding: 8 }} onError={e => { e.target.style.display = 'none'; }} />
                      <div style={{ position: 'absolute', bottom: 4, right: 4, background: 'rgba(27,58,107,0.75)', borderRadius: '50%', width: 20, height: 20, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 11 }}>🔍</div>
                    </>
                  ) : (
                    <span style={{ fontSize: 28 }}>💡</span>
                  )}
                </div>
                <div style={{ padding: '8px 10px 10px' }}>
                  <div style={{ fontSize: 9, fontWeight: 600, color: LARANJA, textTransform: 'uppercase', marginBottom: 2 }}>{nomeLinha(p.linha)}</div>
                  <div style={{ fontSize: 11, color: '#1a1a1a', marginBottom: 4, lineHeight: 1.3 }}>{p.nome}</div>
                  <div style={{ fontSize: 10, color: '#bbb', marginBottom: 6 }}>{p.cod}</div>
                  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <span style={{ fontSize: 13, fontWeight: 600, color: AZUL }}>{formatarPreco(p.preco)}</span>
                    <div onClick={() => abrirModal(p)}
                      style={{ width: 22, height: 22, background: AZUL, borderRadius: 6, display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#fff', fontSize: 16, cursor: 'pointer' }}>
                      +
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>

      {/* Botao Solicitar Visita */}
      <div style={{ padding: '10px 12px', background: CINZA }}>
        <button onClick={() => setModalVisita(true)}
          style={{ width: '100%', background: 'linear-gradient(135deg, #f59e0b, #d97706)', border: 'none', borderRadius: 12, padding: '12px', fontSize: 13, fontWeight: 600, color: '#fff', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8 }}>
          <span style={{ fontSize: 18 }}>📅</span>
          Solicitar Visita do Representante
        </button>
      </div>

      {/* Modal zoom da foto */}
      {fotoZoom && (
        <div onClick={() => setFotoZoom(null)}
          style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.85)', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', zIndex: 9999, padding: 20 }}>
          <div style={{ position: 'absolute', top: 20, right: 20, width: 36, height: 36, background: 'rgba(255,255,255,0.15)', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 20, color: '#fff', cursor: 'pointer' }}>✕</div>
          <div style={{ background: '#ffffff', borderRadius: 16, padding: 16, width: '100%', maxWidth: 320, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 12, boxShadow: '0 4px 32px rgba(27,58,107,0.25)' }}>
            <img src={fotoZoom.url} alt={fotoZoom.nome} style={{ width: '100%', maxHeight: 280, objectFit: 'contain', borderRadius: 8, filter: 'drop-shadow(0px 6px 14px rgba(0,0,0,0.20)) contrast(1.15) brightness(1.05) saturate(1.2)' }} onError={e => { e.target.src = ''; }} />
            <div style={{ fontSize: 13, fontWeight: 600, color: '#1a1a1a', textAlign: 'center' }}>{fotoZoom.nome}</div>
            <div style={{ fontSize: 11, color: '#aaa', textAlign: 'center' }}>Toque fora para fechar</div>
          </div>
        </div>
      )}

      {/* Modal de quantidade */}
      {modalProduto && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'flex-end', zIndex: 100 }}>
          <div style={{ background: '#fff', borderRadius: '16px 16px 0 0', padding: '20px 20px 24px', width: '100%' }}>
            <div style={{ display: 'flex', gap: 12, marginBottom: 16, alignItems: 'center' }}>
              <div onClick={() => modalProduto.img ? setFotoZoom({ url: getImgUrl(modalProduto.img), nome: modalProduto.nome }) : null}
                style={{ width: 52, height: 52, background: '#f8f8f7', borderRadius: 10, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, position: 'relative', cursor: modalProduto.img ? 'zoom-in' : 'default' }}>
                {modalProduto.img ? (
                  <>
                    <img src={getImgUrl(modalProduto.img)} alt={modalProduto.nome} style={{ width: '100%', height: '100%', objectFit: 'contain', padding: 6 }} onError={e => { e.target.style.display = 'none'; }} />
                    <div style={{ position: 'absolute', bottom: 2, right: 2, background: 'rgba(27,58,107,0.75)', borderRadius: '50%', width: 16, height: 16, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 9 }}>🔍</div>
                  </>
                ) : (
                  <span style={{ fontSize: 24 }}>💡</span>
                )}
              </div>
              <div>
                <div style={{ fontSize: 9, fontWeight: 600, color: LARANJA, textTransform: 'uppercase', marginBottom: 2 }}>{nomeLinha(modalProduto.linha)}</div>
                <div style={{ fontSize: 13, fontWeight: 600, color: '#1a1a1a', lineHeight: 1.3 }}>{modalProduto.nome}</div>
                <div style={{ fontSize: 12, color: AZUL, fontWeight: 600, marginTop: 2 }}>{formatarPreco(modalProduto.preco)}</div>
              </div>
            </div>
            <div style={{ marginBottom: 16 }}>
              <div style={{ fontSize: 12, fontWeight: 500, color: '#666', marginBottom: 10, textAlign: 'center' }}>Quantidade</div>
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', border: '1px solid #e0e0dd', borderRadius: 10, overflow: 'hidden', width: 160, margin: '0 auto' }}>
                <button onClick={() => setQtdModal(q => Math.max(1, q - 1))} style={{ width: 44, height: 44, border: 'none', background: '#f4f4f2', color: '#333', fontSize: 22, cursor: 'pointer' }}>−</button>
                <input type="number" min="1" value={qtdModal}
                  onChange={e => { const val = parseInt(e.target.value); if (!isNaN(val) && val >= 1) setQtdModal(val); else if (e.target.value === '') setQtdModal(''); }}
                  onBlur={() => { if (!qtdModal || qtdModal < 1) setQtdModal(1); }}
                  style={{ flex: 1, textAlign: 'center', fontSize: 18, fontWeight: 700, color: '#1a1a1a', border: 'none', outline: 'none', background: '#fff', width: '100%', padding: '0 4px' }} />
                <button onClick={() => setQtdModal(q => (Number(q) || 0) + 1)} style={{ width: 44, height: 44, border: 'none', background: '#f4f4f2', color: '#333', fontSize: 22, cursor: 'pointer' }}>+</button>
              </div>
            </div>
            <div style={{ display: 'flex', gap: 8 }}>
              <button onClick={() => setModalProduto(null)} style={{ flex: 1, background: '#f4f4f2', border: 'none', borderRadius: 10, padding: 13, fontSize: 13, fontWeight: 500, color: '#666', cursor: 'pointer' }}>Cancelar</button>
              <button onClick={confirmarAdicao} style={{ flex: 2, background: AZUL, border: 'none', borderRadius: 10, padding: 13, fontSize: 13, fontWeight: 600, color: '#fff', cursor: 'pointer' }}>Adicionar ao Carrinho</button>
            </div>
          </div>
        </div>
      )}

      {/* Modal Solicitar Visita */}
      {modalVisita && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'flex-end', zIndex: 200 }}>
          <div style={{ background: '#fff', borderRadius: '16px 16px 0 0', padding: '20px 20px 24px', width: '100%', boxSizing: 'border-box' }}>
            <div style={{ fontSize: 15, fontWeight: 700, color: '#1a1a1a', marginBottom: 6 }}>📅 Solicitar Visita</div>
            <div style={{ fontSize: 12, color: '#888', marginBottom: 16 }}>
              Preencha sua preferencia e enviaremos via WhatsApp ao seu representante.
            </div>
            <div style={{ marginBottom: 12 }}>
              <label style={{ fontSize: 11, fontWeight: 500, color: '#666', display: 'block', marginBottom: 4 }}>Data preferida</label>
              <input type="date" value={dataVisita} onChange={e => setDataVisita(e.target.value)}
                style={{ width: '100%', background: '#f8f8f7', border: '1px solid #e0e0dd', borderRadius: 8, padding: '9px 12px', fontSize: 13, outline: 'none', boxSizing: 'border-box', color: '#1a1a1a', fontFamily: 'inherit' }} />
            </div>
            <div style={{ marginBottom: 20 }}>
              <label style={{ fontSize: 11, fontWeight: 500, color: '#666', display: 'block', marginBottom: 4 }}>Horario preferido</label>
              <input type="text" value={horarioVisita} onChange={e => setHorarioVisita(e.target.value)}
                placeholder="Ex: Das 9h as 12h"
                style={{ width: '100%', background: '#f8f8f7', border: '1px solid #e0e0dd', borderRadius: 8, padding: '9px 12px', fontSize: 13, outline: 'none', boxSizing: 'border-box', color: '#1a1a1a', fontFamily: 'inherit' }} />
            </div>
            <div style={{ display: 'flex', gap: 8 }}>
              <button onClick={() => { setModalVisita(false); setDataVisita(''); setHorarioVisita(''); }}
                style={{ flex: 1, background: '#f4f4f2', border: 'none', borderRadius: 10, padding: 13, fontSize: 13, fontWeight: 500, color: '#666', cursor: 'pointer' }}>
                Cancelar
              </button>
              <button onClick={handleSolicitarVisita}
                style={{ flex: 2, background: '#25D366', border: 'none', borderRadius: 10, padding: 13, fontSize: 13, fontWeight: 600, color: '#fff', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8 }}>
                <span>💬</span> Enviar pelo WhatsApp
              </button>
            </div>
          </div>
        </div>
      )}

    </div>
  );
}

export default Catalogo;